import { useGetStructureForCadAlignmentQuery } from '@/__generated__/graphql';
import { useErrorPage } from '@/hooks/useErrorPage';
import { extractStatusCodeFromApolloResponse } from '@/utils';
import { useEffect } from 'react';
import { LoadingSpinnerContainer, Wrapper } from './styles';
import CircularProgress from '@mui/material/CircularProgress';
import { Viewer } from './Viewer/Viewer';

interface CadAlignmentDataProps {
  structureId: string;
  // children: React.ReactNode;
}

export const CadAlignmentData = ({ structureId }: CadAlignmentDataProps) => {
  const { data, loading, error } = useGetStructureForCadAlignmentQuery({
    variables: {
      structureId,
    },
    fetchPolicy: 'cache-first',
  });

  const errorStatusCode = extractStatusCodeFromApolloResponse(
    error?.graphQLErrors[0]?.extensions?.originalError
  );

  const redirectToErrorPage = useErrorPage(errorStatusCode);

  useEffect(() => {
    if (errorStatusCode && redirectToErrorPage) {
      redirectToErrorPage();
    }
  }, [errorStatusCode, redirectToErrorPage]);

  if (loading) {
    return (
      <Wrapper>
        <LoadingSpinnerContainer>
          <CircularProgress size="10rem" />
        </LoadingSpinnerContainer>
      </Wrapper>
    );
  }

  const { octreeResourcesPath, cadOctreeResourcesPath } = data?.structure ?? {};

  if (!data || !octreeResourcesPath || !cadOctreeResourcesPath) {
    return 'Error: octreeResourcesPath or cadOctreeResourcesPath is missing on the structure';
  }

  return <Viewer structureId={structureId} structureData={data} />;
};
